export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '申请编码',
            prop: 'renewalChangeCode',
            minWidth: 120
        },
        // {
        //     label: '修改原因',
        //     prop: 'changeDetail',
        //     minWidth: 240
        // },
        {
            label: '变更原因',
            prop: 'renewalChangeCause',
            minWidth: 260
        },
        {
            label: '审批状态',
            prop: 'renewalChangeFlowStatus',
            type: 'select',
            optionsKey: 'RENEWAL_AUDIT_STATUS',
            minWidth: 100
        },
        {
            label: '创建人',
            prop: 'createUserCode',
            minWidth: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 140
        },
        {
            label: '修改人',
            prop: 'updateUserCode',
            minWidth: 100
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 140
        }
    ]
};
